import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ButtonGroup,
  Text,
  Modal,
} from '../../../../components';

const propTypes = {
  isDeleteOpen: PropTypes.bool.isRequired,
  onDeleteClose: PropTypes.func.isRequired,
  deleteHandler: PropTypes.func.isRequired,
  deleteError: PropTypes.string,
};

const defaultProps = {
  deleteError: null,
};

export default function DeletePlanBenefitCategory({
  isDeleteOpen,
  onDeleteClose,
  deleteHandler,
  deleteError,
}) {
  return (

    <Modal
      title="Delete Plan Benefit"
      isOpen={isDeleteOpen}
      onClose={onDeleteClose}
      closeOnClickOutside={false}
      closeOnEscape={false}
      size="small"
      style={{ zIndex: '1700' }}
    >
      <Modal.Body>
        <Text as="h5">
          Are you sure you want to delete the selected benefit category permanently?
        </Text>
        {deleteError && <Text color="red">{deleteError}</Text>}
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button onClick={onDeleteClose}>Cancel</Button>
          <Button variant="danger" primary onClick={deleteHandler}>Delete</Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
}

DeletePlanBenefitCategory.propTypes = propTypes;
DeletePlanBenefitCategory.defaultProps = defaultProps;
